import React, { useCallback, useEffect, useState } from 'react';
import HarcamaFormu, { paraFormat } from '../components/HarcamaFormu';
import { getHarcamaSecenekleri, getHarcamaKaydedenler, getHarcamaListesi, harcamaIptalEt } from '../services/api';

// Harcama Kaydı Gelişmiş (YETK_WEB_10): filtreli liste + toplam, yeni kayıt popup'ta.
// Masaüstü Dr.Plazma "Harcama Kayıtları" ekranının karşılığı; ek olarak kaydı giren kişi
// hem sütun hem filtre olarak vardır (kullanıcı talebi: 2026-08-20).

// Varsayılan aralık: son 1 hafta (kullanıcı talebi: 2026-08-20).
const gunOnce = (gun) => {
  const d = new Date();
  d.setDate(d.getDate() - gun);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const bugunStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const trTarih = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
};

const etiket = {
  fontSize: 11,
  fontWeight: 700,
  color: 'var(--med-primary)',
  display: 'block',
  marginBottom: 5,
  textTransform: 'uppercase',
  letterSpacing: '.4px',
};

export default function HarcamaKaydiGelismis() {
  const [baslangic, setBaslangic] = useState(gunOnce(7));
  const [bitis, setBitis] = useState(bugunStr());
  const [kasaKod, setKasaKod] = useState('');
  const [kategoriKod, setKategoriKod] = useState('');
  const [whoNo, setWhoNo] = useState('');

  const [kasalar, setKasalar] = useState([]);
  const [kategoriler, setKategoriler] = useState([]);
  const [kaydedenler, setKaydedenler] = useState([]);

  const [kayitlar, setKayitlar] = useState([]);
  const [toplam, setToplam] = useState(0);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [arandi, setArandi] = useState(false);
  const [popupAcik, setPopupAcik] = useState(false);
  const [bilgi, setBilgi] = useState('');

  useEffect(() => {
    getHarcamaSecenekleri()
      .then(res => {
        setKasalar(res.data.kasalar || []);
        setKategoriler(res.data.kategoriler || []);
      })
      .catch(() => setHata('Kasa ve kategori listeleri yüklenemedi.'));

    getHarcamaKaydedenler()
      .then(res => setKaydedenler(res.data || []))
      .catch(() => { /* filtre listesi gelmezse ekran yine çalışır, sadece o dropdown boş kalır */ });
  }, []);

  // Kayıt sonrası listeyi tazelemek için de kullanıldığından useCallback ile sarıldı.
  const listele = useCallback(async (e) => {
    if (e) e.preventDefault();
    setHata('');
    if (!baslangic || !bitis) { setHata('Başlangıç ve bitiş tarihi zorunludur.'); return; }
    if (bitis < baslangic) { setHata('Bitiş tarihi başlangıç tarihinden önce olamaz.'); return; }

    setYukleniyor(true);
    try {
      const params = { baslangic, bitis };
      if (kasaKod) params.kasaKod = kasaKod;
      if (kategoriKod) params.kategoriKod = kategoriKod;
      if (whoNo) params.whoNo = whoNo;

      const res = await getHarcamaListesi(params);
      setKayitlar(res.data.kayitlar || []);
      setToplam(res.data.toplam || 0);
      setArandi(true);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Harcama listesi alınamadı.');
      setKayitlar([]);
      setToplam(0);
    } finally {
      setYukleniyor(false);
    }
  }, [baslangic, bitis, kasaKod, kategoriKod, whoNo]);

  // Ekran açılınca varsayılan aralıkla bir kez listele.
  useEffect(() => { listele(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  const temizle = () => {
    setBaslangic(gunOnce(7));
    setBitis(bugunStr());
    setKasaKod('');
    setKategoriKod('');
    setWhoNo('');
    setHata('');
  };

  // Silme = İPTAL. Satırlar veritabanında kalır, CHI.IPTAL=1 yapılır ve kasa bakiyesi
  // yeniden hesaplanır — masaüstü uygulamasının "sil" davranışının aynısı, geri alınabilir.
  const [silinecek, setSilinecek] = useState(null);
  const [siliniyor, setSiliniyor] = useState(false);

  const iptalEt = async () => {
    if (!silinecek) return;
    setSiliniyor(true);
    setHata('');
    try {
      const res = await harcamaIptalEt(silinecek.masterProtNo);
      setBilgi(`Kayıt iptal edildi — ${paraFormat(res.data.tutar)} TL. ${res.data.yeniBakiye != null ? `Kasanın yeni bakiyesi: ${paraFormat(res.data.yeniBakiye)} TL` : ''}`);
      setSilinecek(null);
      listele();
    } catch (err) {
      setHata(err.response?.data?.hata || 'Kayıt iptal edilemedi.');
    } finally {
      setSiliniyor(false);
    }
  };

  const kayitEklendi = (sonuc) => {
    setPopupAcik(false);
    setBilgi(`Harcama kaydedildi — ${paraFormat(sonuc.tutar)} TL, ${sonuc.kategoriAdi}, ${sonuc.kasaAdi}. Kasanın yeni bakiyesi: ${paraFormat(sonuc.yeniBakiye)} TL`);
    // Yeni kayıt bugünün tarihiyle girilmiş olabilir; filtre aralığı dışındaysa listede
    // görünmez — bu yüzden listeyi tazeleyip kullanıcıya sonucu ayrıca yazıyoruz.
    listele();
  };

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', marginBottom: 20 }}>
        <div>
          <h2 style={{ marginBottom: 4, color: 'var(--med-dark)' }}>📒 Harcama Kayıtları</h2>
          <p style={{ color: 'var(--text-muted)', margin: 0 }}>
            Tarih aralığı zorunludur; diğer filtreler boş bırakılırsa uygulanmaz.
          </p>
        </div>
        <button className="btn btn-primary" onClick={() => { setBilgi(''); setPopupAcik(true); }}>
          ➕ Yeni Harcama Kaydı
        </button>
      </div>

      <form onSubmit={listele} className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 }}>
          <div>
            <label style={etiket}>Başlangıç Tarihi *</label>
            <input type="date" value={baslangic} onChange={e => setBaslangic(e.target.value)} required />
          </div>
          <div>
            <label style={etiket}>Bitiş Tarihi *</label>
            <input type="date" value={bitis} onChange={e => setBitis(e.target.value)} required />
          </div>
          <div>
            <label style={etiket}>Çıkış Kasası</label>
            <select value={kasaKod} onChange={e => setKasaKod(e.target.value)}>
              <option value="">Tümü</option>
              {kasalar.map(k => <option key={k.kod} value={k.kod}>{k.adi}</option>)}
            </select>
          </div>
          <div>
            <label style={etiket}>Kategorisi</label>
            <select value={kategoriKod} onChange={e => setKategoriKod(e.target.value)}>
              <option value="">Tümü</option>
              {kategoriler.map(k => <option key={k.kod} value={k.kod}>{k.adi}</option>)}
            </select>
          </div>
          <div>
            <label style={etiket}>Kaydı Giren</label>
            <select value={whoNo} onChange={e => setWhoNo(e.target.value)}>
              <option value="">Tümü</option>
              {kaydedenler.map(k => <option key={k.kod} value={k.kod}>{k.adi}</option>)}
            </select>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
          <button type="submit" className="btn btn-primary" disabled={yukleniyor}>
            {yukleniyor ? 'Listeleniyor...' : '🔎 Listele'}
          </button>
          <button type="button" className="btn btn-secondary" onClick={temizle} disabled={yukleniyor}>
            Temizle
          </button>
        </div>
      </form>

      {bilgi && <div className="basari-kutu">{bilgi}</div>}
      {hata && <div className="hata-kutu">{hata}</div>}

      {yukleniyor && <div className="loading">Yükleniyor...</div>}

      {!yukleniyor && arandi && kayitlar.length === 0 && (
        <div className="empty">Bu filtrelerle harcama kaydı bulunamadı.</div>
      )}

      {!yukleniyor && kayitlar.length > 0 && (
        <>
          <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 8 }}>
            {kayitlar.length} kayıt bulundu.
          </div>
          <div className="card" style={{ padding: 0, overflowX: 'auto' }}>
            <table className="veri-tablosu">
              <thead>
                <tr>
                  <th>Tarih</th>
                  <th>Saat</th>
                  <th>Açıklama</th>
                  <th>Kategori</th>
                  <th>Çıkış Kasası</th>
                  <th>Kaydı Giren</th>
                  <th style={{ textAlign: 'right' }}>Harcama Tutarı</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {kayitlar.map(k => (
                  <tr key={k.id}>
                    <td style={{ whiteSpace: 'nowrap' }}>{trTarih(k.tarih)}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{k.saat}</td>
                    <td>{k.aciklama}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{k.kategori}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{k.kasaAdi || '—'}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{k.kaydeden || '—'}</td>
                    <td style={{ textAlign: 'right', whiteSpace: 'nowrap', fontWeight: 600 }}>
                      {paraFormat(k.tutar)}
                    </td>
                    <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                      <button
                        className="btn btn-danger"
                        onClick={() => { setBilgi(''); setHata(''); setSilinecek(k); }}
                        title="Kaydı iptal et"
                        style={{ padding: '4px 9px', fontSize: 13 }}
                      >
                        🗑
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={6} style={{ textAlign: 'right', fontWeight: 700, borderTop: '2px solid var(--border)' }}>
                    TOPLAM
                  </td>
                  <td style={{ textAlign: 'right', fontWeight: 800, fontSize: 15, color: 'var(--med-dark)', borderTop: '2px solid var(--border)', whiteSpace: 'nowrap' }}>
                    {paraFormat(toplam)} TL
                  </td>
                  <td style={{ borderTop: '2px solid var(--border)' }}></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </>
      )}

      {silinecek && (
        <div
          onClick={e => { if (e.target === e.currentTarget && !siliniyor) setSilinecek(null); }}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(13,43,94,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: 20, zIndex: 60,
          }}
        >
          <div style={{ background: '#fff', borderRadius: 14, width: '100%', maxWidth: 460, boxShadow: '0 12px 40px rgba(0,0,0,.25)', overflow: 'hidden' }}>
            <div style={{ background: '#A32D2D', padding: '14px 20px' }}>
              <span style={{ color: '#fff', fontSize: 16, fontWeight: 700 }}>🗑 Harcama Kaydını İptal Et</span>
            </div>
            <div style={{ padding: 20 }}>
              <div style={{ fontSize: 13, lineHeight: 1.8, marginBottom: 14 }}>
                <div><strong>{trTarih(silinecek.tarih)} {silinecek.saat}</strong></div>
                <div>{silinecek.aciklama}</div>
                <div style={{ color: 'var(--text-muted)' }}>{silinecek.kategori} · {silinecek.kasaAdi}</div>
                <div style={{ fontSize: 18, fontWeight: 800, color: '#A32D2D', marginTop: 6 }}>
                  {paraFormat(silinecek.tutar)} TL
                </div>
              </div>
              <div style={{ background: '#F6F8F7', borderRadius: 8, padding: '10px 12px', fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.6, marginBottom: 16 }}>
                Kayıt veritabanından silinmez, <strong>iptal</strong> edilir (masaüstü programındaki
                davranışın aynısı). Listeden ve kasa bakiyesinden çıkar; gerekirse geri alınabilir.
                Çıkış kasasının bakiyesi bu tutar kadar <strong>artacaktır</strong>.
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-danger" onClick={iptalEt} disabled={siliniyor} style={{ flex: 1 }}>
                  {siliniyor ? 'İPTAL EDİLİYOR...' : 'EVET, İPTAL ET'}
                </button>
                <button className="btn btn-secondary" onClick={() => setSilinecek(null)} disabled={siliniyor}>
                  Vazgeç
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {popupAcik && (
        <div
          onClick={e => { if (e.target === e.currentTarget) setPopupAcik(false); }}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(13,43,94,0.45)',
            display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
            padding: 20, overflowY: 'auto', zIndex: 50,
          }}
        >
          <div style={{ background: '#fff', borderRadius: 14, width: '100%', maxWidth: 520, boxShadow: '0 12px 40px rgba(0,0,0,.25)', marginTop: 20 }}>
            <div style={{ background: 'linear-gradient(135deg, #1A4A9C, #2563C0)', padding: '14px 20px', borderRadius: '14px 14px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#fff', fontSize: 16, fontWeight: 700 }}>💳 Yeni Harcama Kaydı</span>
              <button onClick={() => setPopupAcik(false)}
                      style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.85)', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>
                ×
              </button>
            </div>
            <div style={{ padding: 20 }}>
              {/* Başarı kutusunu popup göstermez; kapanıp listenin üstünde bilgi satırı çıkar. */}
              <HarcamaFormu onKaydedildi={kayitEklendi} sonucuGoster={false} iptalEt={() => setPopupAcik(false)} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
